module.exports = __webpack_public_path__ + "static/img/yumeigui_icon.4bb2970.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/yumeigui_icon.png
// module id = etVF
// module chunks = 1